import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from "lodash";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignSelectFilesPage",
  mixins: [validationMixin],
  props: {
    /**
     * Normalized documents
     */
    documents: {
      type: Object,
      default: () => ({})
    },
    selectedDocuments: {
      type: Array,
      default: () => []
    },
    currentTemplateData: {
      type: Object,
      default: () => ({})
    }
  },
  validations: {
    selectedDocuments: {
      required
    }
  },
  computed: {
    documentValues() {
      return _Object$values(this.documents);
    },
    templateSelected() {
      return !!this.currentTemplateData.eSignTemplateId;
    },
    isValid() {
      return this.templateSelected || !this.$v.$invalid;
    },
    allDocumentsMarked: {
      get() {
        return this.documentValues.length === this.selectedDocuments.length;
      },
      set(value) {
        this.$emit("select-all-documents", value);
      }
    },
    table() {
      return {
        columns: ["selected", "filename", "documenttype"],
        options: {
          filterable: false,
          sortable: [],
          headings: {
            selected: this.$t("global.words.select"),
            filename: this.$t("e-sign-package.fileName"),
            documenttype: this.$t("e-sign-package.documentType")
          },
          perPage: 999999,
          tabbable: false,
          skin: "table table-hover",
          columnsClasses: {
            selected: "w-10",
            filename: "w-30",
            documenttype: "w-auto"
          },
          texts: {
            noResults: this.$t("e-sign-package.messages.emptyDocs")
          }
        }
      };
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    },
    allDocumentsMarked(value) {
      this.$refs.selectAll.checked = value;
    }
  },
  methods: {
    handleSelectedChange(event, value) {
      let selectedDocuments = cloneDeep(this.selectedDocuments);
      const isChecked = event.target.checked;
      if (isChecked) {
        if (!_includesInstanceProperty(selectedDocuments).call(selectedDocuments, value)) selectedDocuments.push(value);
      } else {
        selectedDocuments = _filterInstanceProperty(selectedDocuments).call(selectedDocuments, dId => dId !== value);
      }
      this.$emit("change", selectedDocuments);
    }
  }
});